import React, { useState } from 'react';
import { CheckBox } from 'components/Inputs/';
import { StyledHeader } from 'components/Settings/';
import { FlexCol, FlexRow } from 'components/Layout/';
import { ReactComponent as ArrowIcon } from 'icons/tick.svg';
import { CancelButton, RoundButton } from 'components/Buttons/';
import { Label, Wrapper, SelectInput } from 'components/Settings/styles';

function Select({ id, value, options, caption, onChange }) {
  return (
    <Wrapper>
      <Label htmlFor={id}>{caption}</Label>
      <SelectInput id={id} value={value} onChange={onChange}>
        {options.map(function (opt) {
          return (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          );
        })}
      </SelectInput>
    </Wrapper>
  );
}

export function EmailNotification({ emails = {}, onClose, onSubmit }) {
  const {
    low_stock: lowStock = false,
    damaged_items: damagedStock = false,
    expired_items: expiredStock = 'none',
    returned_order_summary: returnedSummary = false,
    lease_orders_return_overdue: pastDueDate = 'none',
  } = emails || {};

  const [state, setState] = useState({
    lowStock,
    pastDueDate,
    damagedStock,
    expiredStock,
    returnedSummary,
  });

  const intervals = [
    { value: 'none', label: 'None' },
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
  ];

  function onSelectChanged(e) {
    const { id, value } = e.target;
    setState(function (prevState) {
      return { ...prevState, [id]: value };
    });
  }

  function onOrderCheckChange(e) {
    const { name, checked } = e.target;
    setState(function (prevState) {
      return { ...prevState, [name]: checked };
    });
  }

  function onSubmitSettings() {
    const {
      lowStock,
      pastDueDate,
      expiredStock,
      damagedStock,
      returnedSummary,
    } = state;
    const data = {
      notification_settings: {
        emails: {
          low_stock: lowStock,
          expired_items: expiredStock,
          damaged_items: damagedStock,
          returned_order_summary: returnedSummary,
          lease_orders_return_overdue: pastDueDate,
        },
      },
    };
    onSubmit(data);
  }

  return (
    <>
      <StyledHeader>What to be notified on email</StyledHeader>
      <FlexRow marginBottom={10}>
        <FlexCol flexWidth={12}>
          <CheckBox
            inputName="lowStock"
            caption="Low Stock Alerts"
            isChecked={state.lowStock}
            inputId="low-stock-checkbox"
            onChange={onOrderCheckChange}
          />
        </FlexCol>
      </FlexRow>
      <FlexRow marginBottom={10}>
        <FlexCol flexWidth={12}>
          <Select
            id="expiredStock"
            options={intervals}
            caption="Expired Items"
            value={state.expiredStock}
            onChange={onSelectChanged}
          />
        </FlexCol>
      </FlexRow>
      <FlexRow marginBottom={10}>
        <FlexCol flexWidth={12}>
          <CheckBox
            caption="Damaged Items"
            inputName="damagedStock"
            onChange={onOrderCheckChange}
            isChecked={state.damagedStock}
            inputId="damaged-stock-checkbox"
          />
        </FlexCol>
      </FlexRow>
      <FlexRow marginBottom={10}>
        <FlexCol flexWidth={12}>
          <CheckBox
            inputName="returnedSummary"
            onChange={onOrderCheckChange}
            caption="Returned Order Summary"
            isChecked={state.returnedSummary}
            inputId="returned-summary-checkbox"
          />
        </FlexCol>
      </FlexRow>
      <FlexRow marginBottom={30}>
        <FlexCol flexWidth={12}>
          <Select
            id="pastDueDate"
            options={intervals}
            value={state.pastDueDate}
            onChange={onSelectChanged}
            caption="Lease Orders Past Due Date"
          />
        </FlexCol>
      </FlexRow>
      <FlexRow className="modal-buttons-row">
        <RoundButton
          caption="Save"
          icon={<ArrowIcon />}
          className="modal-button"
          onClick={onSubmitSettings}
        />
        <CancelButton onClick={onClose} />
      </FlexRow>
    </>
  );
}
